import { render, staticRenderFns } from "./SurveyQuestion.vue?vue&type=template&id=6b95ad4c&"
import script from "./SurveyQuestion.vue?vue&type=script&lang=js&"
export * from "./SurveyQuestion.vue?vue&type=script&lang=js&"
import style0 from "./SurveyQuestion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SurveyQuestion.vue"
export default component.exports